import gql from "graphql-tag"

export default gql`
  fragment fullMerchantProductPermissions on ProductPermissions {
    uuid
    businessId
    merchant {
      merchants {
        read
        readAll
        create
        update
      }
      employees {
        read
        canGhost
        canGenerateOnboardingLink
        detach
      }
      locations {
        create
        createOffers
        delete
      }
      canViewMerchantDetails
      canViewMerchantLocations
    }
  }
`
